import { useSkipButton } from '../../common/SkipButton'
import { ViewProps } from '../../types'
import { useReviewFields } from '../useReviewFields'
import { useVideoReview } from '../useVideoReview'
import { VideoReviewView } from './VideoReviewView'

export function VideoReviewLoader(props: ViewProps) {
  const { state, submitForm } = props
  const { reviewFields } = useReviewFields(state.step.fields || [])
  const videoReviewProps = useVideoReview(props, reviewFields)
  const skipProps = useSkipButton(props)

  // Get text review as reference for video review
  const textReview =
    'getValue' in state
      ? state.getValue({
          name: 'comment',
          system: true,
        })
      : undefined

  return (
    <VideoReviewView
      {...videoReviewProps}
      onVideoSubmit={submitForm}
      skipProps={skipProps}
      showSubmit={!!videoReviewProps.videoValue}
      textReview={typeof textReview === 'string' ? textReview : ''}
    />
  )
}
